import React from 'react';
import { Tooltip } from '../../core/tooltip/tooltip.component';
import styles from './buttons.module.scss';
import classNames from 'classnames';

/**
 * @typedef {import('react').ButtonHTMLAttributes<HTMLButtonElement>} AccessibleIconButtonProps
 * @param {AccessibleIconButtonProps & {
 *  label: string,
 *  showTooltip?: boolean,
 * tooltipProps?: import('antd').TooltipProps
 * }} params
 */

export function IconButton({
  label,
  showTooltip = true,
  tooltipProps,
  className,
  disabled = false,
  onClick,
  type = 'button',
  ...props
}) {
  const handleClick = e => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  const button = (
    <button
      {...props}
      type={type}
      onClick={handleClick}
      aria-label={label}
      aria-disabled={disabled}
      className={classNames(styles.iconButton, className)}
    />
  );

  if (showTooltip && label) {
    return (
      <Tooltip {...tooltipProps} title={label} announceOnOpen={false}>
        {button}
      </Tooltip>
    );
  }

  return button;
}
